import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { PropsWithChildren } from "react";

type TanstackQueryClientProviderProps = PropsWithChildren;

export const TanstackQueryClientProvider = (props: TanstackQueryClientProviderProps) => {
  const { children } = props;

  const defaultOptions = {
    queries: { retry: false },
  };

  const queryClient = new QueryClient({ defaultOptions });

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
